import { FC } from 'react';
import { Column } from '../Layout';
import { SharedProps } from './types';
import FileListItem from '../FileListItem';

export type FileListProps = Pick<SharedProps, 'files'> & {
  onDeleteFile?: (fileIndex: number) => void;
};

const FileList: FC<FileListProps> = ({ files, onDeleteFile }) => {
  return (
    <Column spacing="xxs">
      {files?.map((file, index) => {
        const key = `${file.fileName}-${index}`;
        return (
          <FileListItem
            key={key}
            fileName={file.fileName}
            isUploading={file.isUploading}
            showDeleteButton={!!onDeleteFile}
            onDeleteFile={() => {
              if (onDeleteFile) onDeleteFile(index);
            }}
          />
        );
      })}
    </Column>
  );
};

export default FileList;
